var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.026,
    height: 16.758,
    viewBox: "0 0 16.026 16.758",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u041C\\u043D\\u043E\\u0433\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A_1",
    "data-name": "\\u041C\\u043D\\u043E\\u0433\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A 1",
    d: "M6.5,0,13,11H0Z",
    transform: "translate(0 11.258) rotate(-60)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecicon);
export default __webpack_public_path__ + "static/media/rec.icon.e2506899028f4715b7ca3954dc05135e.svg";
export { ForwardRef as ReactComponent };